<template>
    <div class="right-content pr">
        <!--内容区域-->
        <div class="right-content-box">
            <div class="subject-wrap">
                <router-view/>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {

        },
        data() {
            return {};
        },
        created() {
        },
        methods: {}
    };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/layout/RightContent.vue